// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PageIdRouteImport } from './routes/page/$id'
import { Route as AuthErrorRouteImport } from './routes/auth/error'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PageIdRoute = PageIdRouteImport.update({
            id: '/page/$id',path: '/page/$id',getParentRoute: () => rootRouteImport
          })
const AuthErrorRoute = AuthErrorRouteImport.update({
            id: '/auth/error',path: '/auth/error',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthErrorRoute: AuthErrorRoute,PageIdRoute: PageIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)